import { Box, Flex, Progress, Text, VStack } from '@chakra-ui/react';

const BagMeter = ({ value, ticks, threshold = 24 }) => {
  const max = ticks[ticks.length - 1] || 100;
  const isLow = value <= threshold;
  const fillColor = isLow ? "brand.red" : "brand.blue";

  return (
    <VStack width="75%" spacing={1} align="stretch">
      {/* METER BOX (RECTANGLE) */}
      <Box 
        position="relative" 
        border="1px solid" 
        borderColor="card.border" 
        borderRadius="none" 
        boxSizing="border-box"
        height="16px"
        bg="bag.bg"
      >
        <Progress 
           value={value} 
           max={max}
           height="100%" 
           color="white"
           sx={{
             '& > div': {
                backgroundColor: fillColor,
                boxShadow: isLow ? '0 0 10px var(--chakra-colors-brand-red)' : 'none',
                transition: 'background-color 0.3s ease'
             }
           }}
           borderRadius="none"
        />
        
        {/* TICK LINES */}
        <Flex
          position="absolute"
          top="0"
          left="0"
          right="0"
          bottom="0"
          justifyContent="space-between"
          pointerEvents="none"
        >
          {ticks.map((_, index) => (
            <Box 
              key={index} 
              width="1px" 
              height="100%" 
              bg="bag.tick" 
              opacity={0.5}
            />
          ))}
        </Flex>
      </Box>

      {/* TICK NUMBERS */}
      <Flex justifyContent="space-between" width="calc(100% + 14px)" ml="-7px">
        {ticks.map((tick, index) => (
          <Box key={index} width="14px" textAlign="center">
            <Text
              fontSize="9px"
              color="bag.label"
              fontWeight="900"
              lineHeight="1"
            >
              {tick}
            </Text>
          </Box>
        ))}
      </Flex>
    </VStack>
  );
};

export default BagMeter;
